<div class="d-inline-flex" ngbTooltip="{{'buttons.extras.notes' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
    <button class="extra-button violet-red" *checkPermission="noteButton">
        <div *ngIf="noteCounter && noteCounter > 0" class="counter">{{noteCounter}}</div>
        <apc-basic-crud-modal pertinence="subsection" [section]="section" [subsection]="subsection" [subtype]="'extras'"
            [type]="'note'" [icon]="'assets/ico/clipboard-regular.svg'" [isField]="true"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier">
        </apc-basic-crud-modal>
    </button>
</div>

<div class="d-inline-flex" ngbTooltip="{{'buttons.extras.files' | translate}}"tooltipClass="animation-tooltip"  placement="top" container="body" triggers="hover">
    <button
        class="extra-button purple" *checkPermission="fileButton">
        <div *ngIf="fileCounter > 0" class="counter">{{fileCounter}}</div>
        <apc-basic-crud-modal pertinence="subsection" [section]="section" [subsection]="subsection" [subtype]="'extras'"
            [type]="'file'" [icon]="'assets/ico/attachment.svg'" [isField]="true"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier">
        </apc-basic-crud-modal>
    </button>
</div>

<div class="d-inline-flex" ngbTooltip="{{'buttons.extras.customFields' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
    <button
        class="extra-button dark-blue" *checkPermission="customFieldButton">
        <div *ngIf="customFieldCounter > 0" class="counter">{{customFieldCounter}}
        </div>
        <apc-basic-crud-modal pertinence="subsection" [section]="section" [subsection]="subsection" [subtype]="'extras'"
            [type]="'customfield'" [icon]="'assets/ico/briefcase.svg'" [isField]="true"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier">
        </apc-basic-crud-modal>
    </button>
</div>

<div class="d-inline-flex" ngbTooltip="{{'buttons.extras.links' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
    <button
        class="extra-button light-blue" *checkPermission="linkButton">
        <div *ngIf="linkCounter > 0" class="counter">{{linkCounter}}</div>
        <apc-basic-crud-modal [pertinence]="subsection" [section]="section" [subsection]="subsection" [subtype]="'extras'"
            [type]="'link'" [icon]="'assets/ico/link.svg'" [isField]="true"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier">
        </apc-basic-crud-modal>
    </button>
</div>